"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetch = fetch;

var ImmutableAPI = _interopRequireWildcard(require("crm_data/api/ImmutableAPI"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _immutable = require("immutable");

function makeURI(objectType, subjectId) {
  return "/customer-services-integrations/v1/crm/associations/" + objectType + "/" + subjectId + "?hub-id=" + _hubspot.default.get();
}

function fetch(objectType, subjectId) {
  return ImmutableAPI.get(makeURI(objectType, subjectId), {}, function (response) {
    return (0, _immutable.fromJS)(response).map(function (associations) {
      return (0, _immutable.fromJS)({
        objectId: associations.get('objectId'),
        label: associations.get('label')
      });
    });
  });
}